import React, { useEffect, useState, Component } from 'react';
import { ChevronRight, ShoppingCart } from 'lucide-react';
const SWITCHPLATE_OPTIONS = [{
  label: '[Click To Select Size]',
  price: 0
}, {
  label: 'Single Switch',
  price: 0
}, {
  label: 'Double Switch (+$3.00)',
  price: 3.0
}, {
  label: 'Triple Switch (+$6.00)',
  price: 6.0
}, {
  label: 'Quad Switch (+$10.00)',
  price: 10.0
}, {
  label: 'Receptacle (+$2.00)',
  price: 2.0
}, {
  label: 'Four Hole Receptacle (+$6.00)',
  price: 6.0
}, {
  label: 'Combo #1 (+$5.00)',
  price: 5.0
}, {
  label: 'Combo #2 (+$5.00)',
  price: 5.0
}, {
  label: 'Combo #3 (+$8.00)',
  price: 8.0
}, {
  label: 'Combo #4 (+$8.00)',
  price: 8.0
}, {
  label: 'Quad Combo #5 (+$14.00)',
  price: 14.0
}, {
  label: 'Quad Combo #6 (+$14.00)',
  price: 14.0
}, {
  label: 'GFI Single or Decora',
  price: 0
}, {
  label: 'GFI Double (+$3.00)',
  price: 3.0
}, {
  label: 'GFI Triple Switch (+$6.00)',
  price: 6.0
}, {
  label: 'GFI Quad Switch (+$10.00)',
  price: 10.0
}, {
  label: 'GFI Combo #1 (+$5.00)',
  price: 5.0
}, {
  label: 'GFI Combo #2 (+$5.00)',
  price: 5.0
}, {
  label: 'GFI Combo #3 (+$8.00)',
  price: 8.0
}, {
  label: 'GFI Combo #4 (+$8.00)',
  price: 8.0
}, {
  label: 'GFI Quad Combo #5 (+$14.00)',
  price: 14.0
}, {
  label: 'GFI Quad Combo #6 (+$14.00)',
  price: 14.0
}];
export function ProductDetailPage() {
  const [selectedOption, setSelectedOption] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [mainImage, setMainImage] = useState('https://cdn.magicpatterns.com/uploads/kYwoqnKAXP4CNvPbW3sRp7/FG293_List_Image.jpg');
  const basePrice = 10.95;
  const currentPrice = basePrice + SWITCHPLATE_OPTIONS[selectedOption].price;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <section className="bg-cream min-h-screen pb-20" data-id="element-799">
      {/* Breadcrumbs */}
      <div className="bg-cream-dark border-b border-warmBorder mb-8" data-id="element-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-801">
          <nav className="flex items-center gap-2 text-sm text-warmGray" data-id="element-802">
            <a href="#/" className="hover:text-gold transition-colors" data-id="element-803">
              Home
            </a>
            <ChevronRight size={14} className="text-warmGray/50" data-id="element-804" />
            <a href="#/switchplates" className="hover:text-gold transition-colors" data-id="element-805">
              Switchplates
            </a>
            <ChevronRight size={14} className="text-warmGray/50" data-id="element-806" />
            <span className="text-charcoal font-medium" data-id="element-807">
              Butterfly Switchplate Cover
            </span>
          </nav>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-808">
        <div className="flex flex-col lg:flex-row gap-12" data-id="element-809">
          {/* Main Content Area */}
          <div className="flex-grow lg:w-3/4" data-id="element-810">
            <div className="bg-white p-8 rounded-sm shadow-sm border border-warmBorder" data-id="element-811">
              {/* Header Info */}
              <div className="mb-6" data-id="element-812">
                <div className="flex items-center gap-4 text-sm mb-2" data-id="element-813">
                  <span className="font-bold text-charcoal" data-id="element-814">SKU</span>
                  <span className="text-warmGray" data-id="element-815">FG293</span>
                </div>
                <h1 className="text-2xl md:text-3xl font-serif text-charcoal font-bold" data-id="element-816">
                  Butterfly Switchplate Cover
                </h1>
              </div>

              {/* Images */}
              <div className="mb-8 max-w-md" data-id="element-817">
                <div className="aspect-[3/4] bg-cream-dark rounded-sm border border-warmBorder overflow-hidden mb-4 cursor-zoom-in" data-id="element-818">
                  <img src={mainImage} alt="Butterfly Switchplate Cover" className="w-full h-full object-contain" data-id="element-819" />
                </div>
                <div className="flex gap-4" data-id="element-820">
                  <button onClick={() => setMainImage('https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=400&h=400&file=uploaded%2Fimages%2FNew%20Details%2FFG293%20Whole%20Page.jpg')} className="w-20 h-24 border border-warmBorder hover:border-gold transition-colors rounded-sm overflow-hidden bg-cream-dark" data-id="element-821">
                    <img src="https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=75&h=100&file=uploaded%2Fimages%2FNew%20Details%2FFG293%20Whole%20Page.jpg" alt="Thumbnail 1" className="w-full h-full object-cover" data-id="element-822" />
                  </button>
                  <button onClick={() => setMainImage('https://cdn.magicpatterns.com/uploads/kYwoqnKAXP4CNvPbW3sRp7/FG293_List_Image.jpg')} className="w-20 h-24 border border-warmBorder hover:border-gold transition-colors rounded-sm overflow-hidden bg-cream-dark" data-id="element-823">
                    <img src="https://cdn.magicpatterns.com/uploads/kYwoqnKAXP4CNvPbW3sRp7/FG293_List_Image.jpg" alt="Thumbnail 2" className="w-full h-full object-cover" data-id="element-824" />
                  </button>
                </div>
              </div>

              {/* Instructions */}
              <div className="space-y-4 mb-8 text-[#cc0000] font-bold text-lg" data-id="element-825">
                <p data-id="element-826">Click the image above to see a larger version.</p>
                <p data-id="element-827">
                  Please select switchplate type from the dropdown box below.
                  Refer to the image of options above.
                </p>
              </div>

              {/* Purchasing Form */}
              <div className="bg-cream/30 p-6 rounded-sm border border-warmBorder mb-8 max-w-xl" data-id="element-828">
                <div className="space-y-6" data-id="element-829">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-8" data-id="element-830">
                    <label className="font-bold text-charcoal w-24" data-id="element-831">
                      Switchplate
                    </label>
                    <select className="flex-grow p-2 border border-warmBorder rounded-sm bg-white text-charcoal focus:outline-none focus:border-gold" value={selectedOption} onChange={e => setSelectedOption(Number(e.target.value))} data-id="element-832">
                      {SWITCHPLATE_OPTIONS.map((opt, idx) => <option key={idx} value={idx} data-id="element-833">
                          {opt.label}
                        </option>)}
                    </select>
                  </div>

                  <div className="flex items-center gap-8" data-id="element-834">
                    <span className="font-bold text-charcoal w-24" data-id="element-835">
                      This Plate
                    </span>
                    <span className="text-xl font-bold text-charcoal" data-id="element-836">
                      ${currentPrice.toFixed(2)}
                    </span>
                  </div>

                  <div className="flex items-center gap-4 pt-4 border-t border-warmBorder" data-id="element-837">
                    <label className="font-bold text-charcoal" data-id="element-838">Qty</label>
                    <input type="number" min="1" value={quantity} onChange={e => setQuantity(Math.max(1, parseInt(e.target.value) || 1))} className="w-16 p-2 border border-warmBorder rounded-sm text-center focus:outline-none focus:border-gold" data-id="element-839" />
                    <button className="px-8 py-2.5 bg-gold hover:bg-gold-light text-white font-bold rounded-sm transition-colors" data-id="element-840">
                      Add To Cart
                    </button>
                  </div>
                </div>
              </div>

              {/* Description */}
              <div className="mb-8" data-id="element-841">
                <p className="text-charcoal leading-relaxed" data-id="element-842">
                  Butterfly Switchplate with a nice variety of colorful
                  butterflies.
                </p>
              </div>

              {/* Social & Categories */}
              <div className="border-t border-warmBorder pt-6" data-id="element-843">
                <div className="mb-6" data-id="element-844">
                  <button className="bg-[#cb2027] text-white px-3 py-1 rounded-sm text-sm font-bold flex items-center gap-1 hover:bg-[#b01b22] transition-colors" data-id="element-845">
                    <span className="font-serif italic" data-id="element-846">P</span> Save
                  </button>
                </div>

                <div className="flex gap-8" data-id="element-847">
                  <span className="font-bold text-charcoal" data-id="element-848">Categories</span>
                  <div className="flex flex-col gap-1" data-id="element-849">
                    <a href={`#/switchplates?cat=${encodeURIComponent("*WHAT'S NEW*")}`} className="text-[#4267B2] hover:underline text-sm" data-id="element-850">
                      *WHAT'S NEW*
                    </a>
                    <a href={`#/switchplates?cat=${encodeURIComponent('Butterflies, Dragonflies & Bugs')}`} className="text-[#4267B2] hover:underline text-sm" data-id="element-851">
                      Butterflies, Dragonflies &amp; Bugs
                    </a>
                    <a href={`#/switchplates?cat=${encodeURIComponent('Flower Switchplates')}`} className="text-[#4267B2] hover:underline text-sm" data-id="element-852">
                      Flower Switchplates
                    </a>
                    <a href={`#/switchplates?cat=${encodeURIComponent('Quad Switchplates')}`} className="text-[#4267B2] hover:underline text-sm" data-id="element-853">
                      Quad Switchplates
                    </a>
                    <a href={`#/switchplates?cat=${encodeURIComponent('Flower Quads')}`} className="text-[#4267B2] hover:underline text-sm" data-id="element-854">
                      Flower Quads
                    </a>
                    <a href={`#/switchplates?cat=${encodeURIComponent('Nature Quads')}`} className="text-[#4267B2] hover:underline text-sm" data-id="element-855">
                      Nature Quads
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Sidebar Area */}
          <div className="lg:w-1/4 space-y-8" data-id="element-856">
            {/* Login Box */}
            <div className="bg-white p-6 rounded-sm shadow-sm border border-warmBorder" data-id="element-857">
              <a href="#/login" className="text-[#4267B2] hover:underline text-sm block mb-4" data-id="element-858">
                New members sign up here
              </a>
              <p className="text-sm text-charcoal mb-4" data-id="element-859">
                Existing members log in here.
              </p>

              <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-860">
                <div data-id="element-861">
                  <label className="block text-sm font-bold text-charcoal mb-1" data-id="element-862">
                    Email
                  </label>
                  <input type="email" className="w-full p-2 border border-warmBorder rounded-sm focus:outline-none focus:border-gold" data-id="element-863" />
                </div>
                <div data-id="element-864">
                  <label className="block text-sm font-bold text-charcoal mb-1" data-id="element-865">
                    Password
                  </label>
                  <input type="password" className="w-full p-2 border border-warmBorder rounded-sm focus:outline-none focus:border-gold" data-id="element-866" />
                </div>
                <div className="flex gap-2 pt-2" data-id="element-867">
                  <button type="submit" className="flex-1 py-2 bg-gold hover:bg-gold-light text-white text-sm font-bold rounded-sm transition-colors" data-id="element-868">
                    Log In
                  </button>
                  <button type="button" className="flex-1 py-2 bg-gold hover:bg-gold-light text-white text-sm font-bold rounded-sm transition-colors" data-id="element-869">
                    Find Pass
                  </button>
                </div>
              </form>
            </div>

            {/* Mini Cart Box */}
            <div className="bg-white p-6 rounded-sm shadow-sm border border-warmBorder" data-id="element-870">
              <div className="flex flex-col items-start gap-4" data-id="element-871">
                <ShoppingCart className="w-8 h-8 text-warmGray" data-id="element-872" />
                <div className="text-sm text-charcoal" data-id="element-873">
                  <p className="mb-2" data-id="element-874">Your Shopping Cart is empty</p>
                  <p data-id="element-875">
                    Total <span className="font-bold ml-2" data-id="element-876">$0.00</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}